/**
 * Centralised reads of build-time feature flags so callers don't sprinkle
 * `import.meta.env.VITE_...` checks across the codebase.
 */

function readBoolFlag(name: string): boolean {
  const raw = import.meta.env[name]
  if (raw == null) return false
  return String(raw).toLowerCase() === 'true'
}

/**
 * Multi-dimensional A-F match scoring UI (see services PR #154).
 * When false: legacy CircularProgress + percent score.
 * When true: LetterGradeCard + DimensionBars + LegitimacyBadge + RedFlagsPill,
 * with per-row fallback to legacy if a row's letter_grade is null.
 */
export const enableLetterGrades = readBoolFlag('VITE_ENABLE_LETTER_GRADES')
